export default interface FeedBack {
  showFeedBack: boolean;
  color: string | null;
  text: string | null;
}

const feedBackInitialValue: FeedBack = {
  showFeedBack: false,
  color: '',
  text: '',
};

export { feedBackInitialValue };
